import PropTypes from 'constants/PropTypes';

export default {
    // ALL FIELDS - supporting Information
    componentType: PropTypes.oneOfType([PropTypes.func, PropTypes.string]).isRequired,
    // SOME FIELDS - Supporting Information
    label: PropTypes.node,
    placeholder: PropTypes.string,
    popover: PropTypes.popover,
    instructions: PropTypes.shape({
        title: PropTypes.string,
        text: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    }),
    showSuccessOnValid: PropTypes.bool,
};
